<template>
    <div class="d-flex flex-column fill-height">
        <v-row ref="headerFilters" class="flex-grow-0">
            <data-table-filters v-if="!isMobile"
                :name="tb('Estatísticas - Compras Mês')"
                :has-active-filters="hasActiveFilters"
                :filters="filters"
                :schema="tSchema(schema)"
                :has-expanded-active-filters="hasExpandedActiveFilters"
                @expand-active-filters="hasExpandedActiveFilters = $event"
                @remove-filter="removeFilter"
                @refresh="refresh"
                @clear-filters="onClearFilters()"
                :yearsList="schema && schema.homologous_period ? schema.homologous_period.items : undefined"
            >
            </data-table-filters>
            <div class="col wrap-title-filters" v-else >
                <filters-dialog
                    :isMonthlyPurchases="true"
                    :name="tb('Estatísticas - Compras Mês')"
                    :has-active-filters="hasActiveFilters"
                    :filters="filters"
                    :schema="tSchema(schema)"
                    :has-expanded-active-filters="hasExpandedActiveFilters"
                    @expand-active-filters="hasExpandedActiveFilters = $event"
                    @remove-filter="removeFilter"
                    @refresh="refresh"
                    @clear-filters="onClearFilters()"
                    >
                </filters-dialog>
            </div>
        </v-row>

        <v-row class="flex-grow-1">
            <v-col>
                <pure-datatable endpoint="/api/statistics/monthly-purchases" @data-changed="onDataChanges" :queryParams="queryParams" :ready="ready" ref="datatable" v-slot:default="{ vOn, vBind, isLoading }">
                    <div>
                        <portal to="v-form-base">
                            <v-form-base :model="filters" :schema="tSchema(schema)" @input="onFiltersChanged"> </v-form-base>
                        </portal>

                        <v-data-table id="monthly_purchases"
                            class="elevation-1 d-flex flex-column justify-space-between no-extra-padding-data-table nowrap-headers"
                            :style="`border-radius: 16px; height: ${datatableSize}px;`"
                            fixed-header
                            multi-sort
                            :items="displayItems"
                            :headers="tHeaders(headers)"
                            :hide-default-headers="isMobile"
                            :header-props="headerProps"
                            @update:options="refresh"
                            v-on="vOn"
                            v-bind="vBind"
                            hide-default-footer
                            :no-data-text="$t('table.noData')"
                            :no-results-text="$t('table.noResults')"
                            :group-by="'branch_identifier'"
                            :loading="isMobile?isLoading:false"
                            :loading-text="$t('table.loading')"
                            :footer-props="footerProps"
                        >
                            <template #[`group.header`]="{ items, isOpen, toggle }">
                                <th colspan="100%">
                                    <v-icon @click="toggle">{{ isOpen ? 'mdi-minus' : 'mdi-plus' }} </v-icon>

                                    <v-icon :class="getBranchColor(items[0])" class="appbar-icon-button-smaller elevation-1 mr-1 no-background-hover dark-blue-color">
                                        {{ getBranchIcon(items[0]) }}
                                    </v-icon>

                                    {{ items[0].name }}

                                    <!-- If petfood === null, assuming this is a consolidated branch and will display the number as such -->
                                    <span v-if="userStore.hasPermissionTo('View client and branch number')">&nbsp;({{ items[0].is_petfood === null ? items[0].client_number : items[0].branch_identifier }})</span>
                                </th>
                            </template>

                            <template v-if="!isMobile" #item.sum="scope">
                                <div v-if="scope.item.isTotalRow" class="datatable-multi-line-text">
                                    {{ formatPrice(scope.item.total_sum) }}
                                </div>

                                <div v-else class="datatable-multi-line-text">
                                    {{ formatPrice(scope.item.sum) }}
                                </div>
                            </template>

                            <template v-if="!isMobile" #item.sum_minus_one="scope">
                                <div v-if="scope.item.isTotalRow" class="datatable-multi-line-text">
                                    {{ formatPrice(scope.item.total_sum_minus_one) }}
                                </div>

                                <div v-else class="datatable-multi-line-text">
                                    {{ formatPrice(scope.item.sum_minus_one) }}
                                </div>
                            </template>

                            <template v-if="!isMobile" #item.variation_minus_one="scope">
                                <div v-if="!scope.item.isTotalRow" :class="calcColor(scope.item.variation_minus_one)" class="datatable-multi-line-text">{{ scope.item.variation_minus_one }}%</div>
                            </template>

                            <template v-if="!isMobile" #item.sum_minus_two="scope">
                                <div v-if="scope.item.isTotalRow" class="datatable-multi-line-text">
                                    {{ formatPrice(scope.item.total_sum_minus_two) }}
                                </div>

                                <div v-else class="datatable-multi-line-text">
                                    {{ formatPrice(scope.item.sum_minus_two) }}
                                </div>
                            </template>

                            <template v-if="!isMobile" #item.variation_minus_two="scope">
                                <div v-if="!scope.item.isTotalRow" :class="calcColor(scope.item.variation_minus_two)" class="datatable-multi-line-text">{{ scope.item.variation_minus_two }}%</div>
                            </template>

                            <template v-if="!isMobile" #item.month="scope">
                                <div v-if="!scope.item.isTotalRow" class="datatable-multi-line-text">
                                    {{ getMonth(scope.item.month) }}
                                </div>
                            </template>
                            <template v-if="isMobile" v-slot:item="{ item, index }">
                                <tr>
                                    <v-card
                                    elevation="2" :class="item.isTotalRow?'wrap-total':''"
                                    >
                                    <v-row>
                                        <v-col class="d-flex flex-column col pt-0 pb-0">
                                            <v-row class="d-flex align-start pt-0 pb-0">
                                                <v-col class="col col-4 px-0 pt-0 pb-0 wrap-l">
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" v-if="!item.isTotalRow">{{ tb('MÊS') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" v-html="!item.isTotalRow?tb('VALOR'):tb('TOTAL')">{{ tb('VALOR') }} </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" v-if="item.total_sum_minus_one">{{ tb('VALOR (N-1)') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" v-if="item.variation_minus_one">{{ tb('VARIAÇÃO (N-1)') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" v-if="item.total_sum_minus_two">{{ tb('VALOR (N-2)') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" v-if="item.variation_minus_two">{{ tb('VARIAÇÃO (N-2)') }}</v-col>
                                                </v-col>
                                                <v-col class="col col-8  pt-0 pb-0 wrap-r">
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r"  v-if="!item.isTotalRow">
                                                        <div class="datatable-designation-text">
                                                            <div v-if="!item.isTotalRow" class="datatable-multi-line-text">
                                                                {{ getMonth(item.month) }}
                                                            </div>
                                                        </div>
                                                    </v-col>

                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                        <div class="datatable-designation-text">
                                                            <div v-if="item.isTotalRow" class="datatable-multi-line-text">
                                                                    {{ formatPrice(item.total_sum) }}
                                                                </div>

                                                                <div v-else class="datatable-multi-line-text">
                                                                    {{ formatPrice(item.sum) }}
                                                                </div>
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="item.total_sum_minus_one">
                                                        <div class="datatable-designation-text" style="cursor: pointer">
                                                            <div v-if="item.isTotalRow" class="datatable-multi-line-text">
                                                                {{ formatPrice(item.total_sum_minus_one) }}
                                                            </div>

                                                            <div v-else class="datatable-multi-line-text">
                                                                {{ formatPrice(item.sum_minus_one) }}
                                                            </div>
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="item.variation_minus_one">
                                                        <div class="datatable-designation-text" style="cursor: pointer">
                                                            <div v-if="!item.isTotalRow" :class="calcColor(item.variation_minus_one)" class="datatable-multi-line-text">{{item.variation_minus_one }}%</div>
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="item.total_sum_minus_two">
                                                        <div class="datatable-designation-text" style="cursor: pointer">
                                                            <div v-if="item.isTotalRow" class="datatable-multi-line-text">
                                                                {{ formatPrice(item.total_sum_minus_two) }}
                                                            </div>

                                                            <div v-else class="datatable-multi-line-text">
                                                                {{ formatPrice(item.sum_minus_two) }}
                                                            </div>
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="item.variation_minus_two">
                                                        <div class="datatable-designation-text" style="cursor: pointer">
                                                            <div v-if="!item.isTotalRow" :class="calcColor(item.variation_minus_two)" class="datatable-multi-line-text">{{item.variation_minus_two }}%</div>
                                                        </div>
                                                    </v-col>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    </v-card>
                                </tr>
                            </template>

                            <template v-slot:footer="scope">
                                <div>
                                    <div class="datatable-footer-border"></div>

                                    <data-table-footer :showExport="canExport()" @export="exportData" :scope="scope" @updateOptions="refresh" :showOrderButton="false" :isLoading="isLoading" style="height: fit-content"> </data-table-footer>
                                </div>
                            </template>
                        </v-data-table>
                    </div>
                </pure-datatable>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { i18n } from '@/i18n';
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { useAppStore } from '@/Stores/app';
import PureDatatable from '@arentia/atools/PureDatatable';
import MainLayout from './../../Layouts/MainLayout';
import VFormBase from 'vuetify-form-base';
import ResizeObserver from 'resize-observer-polyfill';


export default {
    layout: MainLayout,

    components: {
        PureDatatable,
        VFormBase,
    },

    props: {
        model: [Object, Array],
        schema: [Object, Array],
    },

    data: () => ({
        datatableSize: 200,
        chartContainerSize: 200,
        resizeObserver: null,

        filters: {},
        queryParams: {},
        footerProps: {
            showFirstLastPage: false,
            itemsPerPageOptions: [12, 24, 60],
            itemsPerPageText: i18n.t('table.itemsPerPage'),
        },

        ready: false,
        hasExpandedActiveFilters: false,

        hasN1Active: false,
        hasN2Active: false,

        purchases: [],
        headers: [],

        statistics: [],
        first:false
    }),

    created() {
        if(this.isMobile){
            this.getPrefilledBranches()
        }else{
            this.applyDefaultFilters();
        }
    },

    mounted() {
        this.prepareResponsiveBehaviour();
        if(!this.isMobile){
            this.refresh();
        }
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.makeResponsive);
        this.resizeObserver?.unobserve(this.$refs.headerFilters);
    },

    watch: {
        'branchStore.branch': {
            handler: function (branch) {
                if (!branch) return;

                this.queryParams.branch_id = branch.id;
                this.queryParams.isMobile = this.isMobile;
                this.ready = true;

                if(!this.isMobile){
                    this.refresh();
                }else{
                    if(this.first){
                        this.refresh();
                    }else{
                        this.getPrefilledBranches()
                    }
                }

            },
            immediate: true,
        },
    },

    computed: {
        ...mapStores(useUserStore, useBranchStore,useAppStore),

        displayItems() {
            if (!this.purchases || this.purchases.length === 0) {
                return [];
            }

            // Group the rows by their client_number and company_branch
            const group = this.purchases.reduce((group, item) => {
                const key = item.client_number + '' + item.company_branch;

                group[key] = group[key] ?? [];
                group[key].push(item);
                return group;
            }, {});

            // Prepend a new row for the totals for each branch/consolidated client
            for (const key in group) {
                const firstRow = group[key][0];
                const rowWithTotalValues = Object.assign({ isTotalRow: true }, firstRow);

                group[key].unshift(rowWithTotalValues);
            }

            return Object.values(group).flat();
        },

        hasActiveFilters() {
            return Object.values(this.filters)
                .filter((x) => x) // ignore null or undefined
                .some((x) => (typeof x === 'string' && x !== '') || (Array.isArray(x) && x.length > 0) || (typeof x === 'object' && Object.keys(x).length > 0));
        },

        //
        // Charts
        //
        getChartPriceSeries() {
            const branchSeries = [];

            // Process and add the information from each branch into the branches array
            this.statistics?.forEach((branch) => {
                const data = [branch.sum];
                if (this.hasN1Active) data.push(branch.sum_minus_one);
                if (this.hasN2Active) data.push(branch.sum_minus_two);

                branchSeries.push({
                    name: `${branch.name} ${this.userStore.hasPermissionTo('View client and branch number') ? '(' + branch.branch_identifier + ')' : ''}`,
                    data: data,
                });
            });

            return branchSeries;
        },

        categories() {
            const data = [];
            data.push(this.tb('Período Atual'));
            if (this.hasN1Active) data.push('N - 1');
            if (this.hasN2Active) data.push('N - 2');
            return data;
        },
        isMobile(){
            return this.appStore.mobile_ls?false:this.appStore.is_mobile;
        },
        headerProps(){
            return this.appStore.header_props
        }
    },

    methods: {
        getPrefilledBranches(){
             axios
                .get('/api/branches/prefilled-branches')
                .then((response) => {
                       let result = response.data
                       this.model['branches##id']=[];
                       for(let field in result){
                          this.model['branches##id'].push({id:result[field].id})
                       }
                       this.applyDefaultFilters();

                       if(!this.first){
                            this.$nextTick(_=>{
                                this.first=true
                                this.refresh()
                            })
                       }


                }).catch((error) => {
                    console.log(error);
                });
        },
        canExport() {
            return this.userStore.hasPermissionTo('Export monthly purchases');
        },
        exportData() {
            if (!this.branchStore.branch || !this.$refs.datatable) return;

            const axiosSettings = {
                url: '/api/statistics/monthly-purchases/export',
                params: {
                    branch_id: this.branchStore.branch.id,
                },
            };

            this.$refs.datatable.exportData(axiosSettings, 'export_compras_mes');
        },

        getBranchIcon(branch) {
            switch (branch.is_petfood) {
            case true:
                return 'mdi-alpha-p';
            case false:
                return 'mdi-alpha-f';
            case null:
                return 'mdi-alpha-c';
            }
        },

        getMonth(n) {
            switch (n) {
            case 1:
                return this.tb('Janeiro');
            case 2:
                return this.tb('Fevereiro');
            case 3:
                return this.tb('Março');
            case 4:
                return this.tb('Abril');
            case 5:
                return this.tb('Maio');
            case 6:
                return this.tb('Junho');
            case 7:
                return this.tb('Julho');
            case 8:
                return this.tb('Agosto');
            case 9:
                return this.tb('Setembro');
            case 10:
                return this.tb('Outubro');
            case 11:
                return this.tb('Novembro');
            case 12:
                return this.tb('Dezembro');
            default:
                break;
            }
        },

        calcColor(value) {
            if (value < 0) {
                return 'red-color';
            }
            if (value > 0) {
                return 'green-color';
            }
        },

        getBranchColor(branch) {
            return branch.is_petfood === 1 ? 'btn-bg-color-navbar-petfood-inactive' : 'btn-bg-color-blue';
        },

        prepareResponsiveBehaviour() {
            this.resizeObserver = new ResizeObserver(this.makeResponsive);
            this.resizeObserver.observe(this.$refs.headerFilters);

            window.addEventListener('resize', this.makeResponsive);

            this.makeResponsive();
        },

        makeResponsive() {
            this.computeDatatableSize();
            this.computeChartContainerSize();
        },

        computeDatatableSize() {
            const topElement = this.$refs.headerFilters;

            if (topElement) {
                const topHeight = topElement.getBoundingClientRect().bottom;
                const res = window.innerHeight - 75 - topHeight;
                this.datatableSize = res;
            }
        },

        computeChartContainerSize() {
            const topElement = this.$refs.headerFilters;

            if (topElement) {
                const topHeight = topElement.getBoundingClientRect().bottom;
                const res = window.innerHeight - 102 - topHeight;
                this.chartContainerSize = res;
            }
        },

        removeFilter(filters, index) {
            filters.splice(index, 1);
            this.onFiltersChanged();
        },
        onFiltersChanged() {
            let hasAutoSearch = this.userStore.user?.auto_search_disabled
            if(this.isIOS()){
                if(!hasAutoSearch){
                    this.setFiltersChanged()
                }
            }else{
                this.setFiltersChanged()
            }
        },
        setFiltersChanged(){
                this.refresh();
                window.EventBus.$emit('check-if-should-overflow');
                window.EventBus.$emit('check-if-should-underflow');
        },

        refresh(options) {
            if (!this.branchStore.branch) return;

            if (this.filters.consolidated == 'Consolidar') {
                this.filters.is_petfood = '';
                this.schema.is_petfood.disabled = true;
            } else {
                this.schema.is_petfood.disabled = false;
            }

            this.hasN1Active = this.filters?.homologous_period__id?.find((el) => el.id == 1) ? true : false;
            this.hasN2Active = this.filters?.homologous_period__id?.find((el) => el.id == 2) ? true : false;

            if (this.$refs.datatable) {
                const defaultOptions = {
                    itemsPerPage: this.footerProps.itemsPerPageOptions.at(0),
                };

                this.$refs.datatable.setLocalOptions(options ?? defaultOptions);
                this.$refs.datatable.onChangeQueryBuilder(this.filters, this.schema);
            }
            this.calcHeaders();
        },

        calcHeaders() {
            let paddingWidth = 0;
            if (!this.hasN1Active) paddingWidth += 25;
            if (!this.hasN2Active) paddingWidth += 25;
            const headers = [
                {
                    text: '',
                    align: 'center',
                    sortable: false,
                    value: '',
                    width: paddingWidth + '%',
                },
                {
                    text: 'Valor',
                    align: 'center',
                    sortable: false,
                    value: 'sum',
                    width: '12.5%',
                },
            ];
            if (this.hasN1Active) {
                headers.push(
                    {
                        text: 'Valor N-1',
                        align: 'center',
                        sortable: false,
                        value: 'sum_minus_one',
                        width: '12.5%',
                    },
                    {
                        text: 'Variação (N-1)',
                        align: 'center',
                        sortable: false,
                        value: 'variation_minus_one',
                        width: '12.5%',
                    }
                );
            }
            if (this.hasN2Active) {
                headers.push(
                    {
                        text: 'Valor N-2',
                        align: 'center',
                        sortable: false,
                        value: 'sum_minus_two',
                        width: '12.5%',
                    },
                    {
                        text: 'Variação (N-2)',
                        align: 'center',
                        sortable: false,
                        value: 'variation_minus_two',
                        width: '12.5%',
                    }
                );
            }

            headers.push({
                text: 'Mês',
                align: 'center',
                sortable: false,
                value: 'month',
                width: '12.5%',
            });
            this.headers = headers;
        },

        onDataChanges(value) {
            // Update local data so that we can later display the total sum.
            this.$set(this, 'purchases', value?.data ?? []);

            const wrapper = this.$refs['datatable']?.$el?.querySelector('div.v-data-table__wrapper');
            this.scrollDatatableToTop(this.$vuetify, wrapper);
        },

        applyDefaultFilters() {
            for (let field in this.model) {
                this.$set(this.filters, field, this.model[field]);
            }
        },

        onClearFilters() {
            this.applyDefaultFilters();
            this.hasExpandedActiveFilters = false;

            this.refresh();
        },
    },
};
</script>

<style>
.max-pagination-height > .v-pagination {
    height: 24px !important;
}
.max-pagination-height > .v-pagination .v-pagination__item {
    font-size: 12px !important;
}

.v-text-field {
    margin-top: 0 !important;
}

.v-text-field input {
    padding: 4px 0 !important;
    margin-top: 0 !important;
}

#form-base > div > .v-input > .v-input__control > .v-input__slot .v-input__icon--prepend-inner button.v-icon {
    color: #154579;
    font-size: 18px !important;
}
</style>

<style scoped>
.statistics-card-title {
    font-size: 0.65rem !important;
    width: 83px;
}
.statistics-card-subtitle {
    font-size: 0.65rem !important;

    width: 97px;
}
.statistics-card {
    height: 120px;
    width: 180px;
}
.statistics-title {
    font-size: 1rem !important;
}
.top-purchases-column-chart {
    height: 280px;
    width: 700px;
}
@media only screen and (min-width: 1300px) {
    .top-purchases-column-chart {
        height: 350px;
        width: 700px;
    }
}

@media only screen and (min-width: 1600px) {
    .statistics-card-title {
        font-size: 0.75rem !important;
    }
    .statistics-card-subtitle {
        font-size: 0.75rem !important;
    }
    .statistics-card {
        height: 125px;
        width: 200px;
    }

    .top-purchases-column-chart {
        height: 350px;
        width: 1000px;
    }

    .top-purchases-chart-container {
        padding-top: 16px;
    }
}
</style>
